<div class="wrapper" [style.--duration]="duration">
  <div
    class="progress-bar"
    [class.progress-bar-animation]="showAnimation"
    [class]="feedbackTypeClass"
    [style.background]="color"
  ></div>
</div>
